package com.evoapps.evoshift.domain.usecase

import com.evoapps.evoshift.domain.model.RosterPublishing
import com.evoapps.evoshift.domain.repository.ShiftRepository

class UnassignShiftFromEmployeeUseCase(
    private val shiftRepository: ShiftRepository,
    /** Reprices the shift for its new assignee (financial managers; best effort, see SH-12). */
    private val calculateShiftCost: CalculateShiftCostUseCase? = null
) {
    suspend operator fun invoke(shiftId: String): Result<Unit> {
        return try {
            val shift = shiftRepository.getShift(shiftId).getOrNull()
            if (shift == null) {
                Result.failure(Exception("Shift not found"))
            } else {
                val updatedShift = shift.copy(
                    userId = null,
                    userDisplayName = null,
                    // A forced double booking was about the person, not the empty slot.
                    conflictMetadata = null,
                    hasUnpublishedChanges = true,
                    // SH-271: the next publish tells who had it.
                    publishedUserId = RosterPublishing.publishedAssignee(shift, null)
                )
                shiftRepository.updateShift(updatedShift).onSuccess { calculateShiftCost?.invoke(shiftId) }
            }
        } catch (e: Exception) {
            Result.failure(e)
        }
    }
}
